module.exports = __webpack_public_path__ + "static/motif--header-063286e39da68906a9764fd51c514a85.svg";